// extracted by mini-css-extract-plugin
var _1 = "PhaseStripError-modulePhaseStripError__I1cHj";
var _2 = "PhaseStripError-moduletext__Rgt3W";
export { _1 as "PhaseStripError", _2 as "text" }
